/*
 * @Author: your name
 * @Date: 2021-09-22 23:19:38
 * @LastEditTime: 2024-02-20 11:00:26
 * @LastEditors: wuqinfa
 * @Description: In User Settings Edit
 * @FilePath: /mxc-crm-3.0/src/services/template.ts
 */
import request from '@/utils/request';

/**
 * 获取系统全部字典
 */
export async function dictionary(params: any) {
  return request('/crm-account/dictionary/all', {
    method: 'GET',
    params: params,
  });
}

/**
 * 获取全部学校
 */
export async function allSchoolList(params: any) {
  return request('/crm-campus/school/list', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 *  国内所有城市 + 国外只到国家
 */
export async function listAllCity(params: any) {
  return request('/crm-account/city/listAllCity', {
    method: 'GET',
    params: params
  });
}

/**
 * 获取所有的课程等级
 */
export async function courseLayers(params: any) {
  return request('/course/courseLayers', {
    method: 'GET',
    data: params,
    baseURL: API_URL_V2,
  });
}